import * as React from 'react';
import Icon from '../Icon';


var CloseIcon = function (_a) {
    var onClick = _a.onClick;
    return (React.createElement(Icon, { width: "20", height: "20", viewBox: "0 0 20 20", fill: "none", className: 'CloseIcon', onClick: onClick },
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M16.1751 3L10 9.17512L3.82485 3L3 3.82485L9.17515 10L3 16.1751L3.82485 17L10 10.8249L16.1751 17L17 16.1751L10.8249 10L17 3.82485L16.1751 3Z", fill: "#292828" })));
};
export default React.memo(CloseIcon);
